import { requestJSON } from "../../utils/promises/library";

const testErrors = (json) => {
    if (Array.isArray(json)) {
        return json.some((result) => result.errors && result.errors.length)
            ? Promise.reject(json.map((result) => result.errors))
            : json.map((result) => result.data);
    } else {
        return json.errors ? Promise.reject(json.errors) : json.data;
    }
};

/**
 * Get the correct fetch based on isPreview flag
 * @param {boolean} isPreview
 * @return {Function} regular fetch or preview fetch with X-Internal in the header
 */
const baseFetch = (isPreview = false) => {
    return (url, query, rejectOnAnyError = true) => {
        const headers = {
            "Content-Type": "application/json",
        };
        if (isPreview) {
            headers["X-Internal"] = 1;
        }
        return requestJSON(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(query),
            credentials: "omit",
        }).then((json) => {
            if (rejectOnAnyError) {
                return testErrors(json);
            }
            return Promise.resolve(json);
        });
    };
};

/**
 * Get results of query
 * @param {string} url
 * @param {object} query
 * @param {boolean} rejectOnAnyError
 * @return {Promise<Object|Array.<Object>} if query is an array, resolves to an array of results
 */
export const fetchWithHeaders = (
    url,
    query,
    headers = {},
    rejectOnAnyError = true
) => {
    const mergedHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    return requestJSON(url, {
        method: "POST",
        headers: mergedHeaders,
        body: JSON.stringify(query),
    }).then((json) => {
        if (rejectOnAnyError) {
            return testErrors(json);
        }
        return Promise.resolve(json);
    });
};

const fetch = baseFetch();
const fetchPreview = baseFetch(true);

export { fetch, fetchPreview, baseFetch };
